import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_CONFIRMATION_FEATURE_KEY,
  PaymentConfirmationState,
} from './paymentConfirmation.slice';

export const getConfirmationFormState = (
  rootState: any,
): PaymentConfirmationState => rootState[PAYMENT_CONFIRMATION_FEATURE_KEY];

export const selectFieldConfigurations = createSelector(
  getConfirmationFormState,
  (s) => s.fieldConfigurations,
);

export const selectConfirmationData = createSelector(
  getConfirmationFormState,
  (s) => s.confirmationData,
);

export const selectIsConfirmationFormLoading = createSelector(
  getConfirmationFormState,
  (s) => s.isLoading,
);
